/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../core/has.js";
import { isSome as r } from "../core/maybe.js";
import { isAborted as o } from "../core/promiseUtils.js";

function t(t, i) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var c = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (d, a) {
    if (o(c)) return void a(n());

    var m = function m() {
      v(), a(new Error("Unable to load ".concat(i)));
    },
        l = function l() {
      var e = t;
      v(), d(e);
    },
        u = function u() {
      if (!t) return;
      var e = t;
      v(), e.src = "", a(n());
    };

    var v = function v() {
      e("esri-image-decode") || (t.removeEventListener("error", m), t.removeEventListener("load", l)), m = null, l = null, t = null, r(c) && c.removeEventListener("abort", u), u = null, s && URL.revokeObjectURL(i);
    };

    r(c) && c.addEventListener("abort", u), e("esri-image-decode") ? t.decode().then(l, m) : (t.addEventListener("error", m), t.addEventListener("load", l));
  });
}

function n() {
  try {
    return new DOMException("Aborted", "AbortError");
  } catch (_unused) {
    var _e = new Error();

    return _e.name = "AbortError", _e;
  }
}

export { t as loadImageAsync };